module.exports = __webpack_public_path__ + "img/purchase-guide.86bf2634.jpg";